import Vue from "vue";

import websocket from "@/utils/websocket/index";
export const process = {
  methods: {
    //获取情景列表
    async getSceneList() {
      let res = await this.$http.get("/tenant/emergency/scene/list");

      return res;
    },
    //根据情景id查找流程列表
    async getFlowList(sceneId) {
      let res = await this.$http.get(`/tenant/emergency/flow/list/${sceneId}`);
      return res;
    },
    //新增情景
    async addScene(obj) {
      let res = await this.$http.post("/tenant/emergency/scene", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //修改情景
    async upScene(obj) {
      let res = await this.$http.put("/tenant/emergency/scene", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //删除情景
    async delScene(id) {
      let res = await this.$http.delete(`/tenant/emergency/scene/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //新增流程
    async addFlow(obj) {
      let res = await this.$http.post("/tenant/emergency/flow", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //修改流程
    async upFlow(obj) {
      let res = await this.$http.put("/tenant/emergency/flow", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //删除流程
    async delFlow(id) {
      let res = await this.$http.delete(`/tenant/emergency/flow/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //根据流程id查询流程小组
    async getFlowTemList(sceneId) {
      let res = await this.$http.get(`/tenant/emergency/flow/group/list/${sceneId}`);
      return res;
    },
    //TODO： 新增应急小组
    async addGroupTem(obj) {
      let res = await this.$http.post("/tenant/emergency/flow/group", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改小组
    async upGroupTem(obj) {
      let res = await this.$http.put("/tenant/emergency/flow/group", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除小组
    async delGroupTem(id) {
      let res = await this.$http.delete(`/tenant/emergency/flow/group/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //TODO： 新增应急小组角色
    async addGroupTemRoles(obj) {
      let res = await this.$http.post("/tenant/emergency/flow/group/role", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 修改小组角色
    async upGroupTemRoles(obj) {
      let res = await this.$http.put("/tenant/emergency/flow/group/role", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO： 删除小组角色
    async delGroupTemRoles(id) {
      let res = await this.$http.delete(`/tenant/emergency/flow/group/role/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //TODO：根据应急小组id查询角色列表
    async getSuTemRolesPages(params) {
      let { pageNum, pageSize ,groupId} = params;
      let res = await this.$http.get(`/tenant/emergency/flow/group/role/page`, {
        groupId:groupId ?? groupId,
        pageNum,
        pageSize,
      });
      return res;
    },

    //保存流程排序
    async saveFlowSort(obj) {
      let res = await this.$http.put("/tenant/emergency/flow/sort", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //保存小组排序
    async saveGroupSort(obj) {
      let res = await this.$http.put("/tenant/emergency/flow/group/sort", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },

    //  //TODO： 新增应急小组
    //  async addProcess(obj) {
    //   let res = await this.$http.post("/tenant/emergency/group", obj);
    //   if (res.code == 200) {
    //     this.$message({ message: res.msg, type: "success" });
    //   } else {
    //     this.$message.error(res.msg);
    //   }
    //   return res;
    // },
    // //TODO： 修改应急小组
    // async upSuTem(obj) {
    //   let res = await this.$http.put("/tenant/emergency/group", obj);
    //   if (res.code == 200) {
    //     this.$message({ message: res.msg, type: "success" });
    //   } else {
    //     this.$message.error(res.msg);
    //   }
    //   return res;
    // },
    // //TODO： 删除应急小组
    // async delSuTem(id) {
    //   let res = await this.$http.delete(`/tenant/emergency/group/${id}`);
    //   if (res.code == 200) {
    //     this.$message({ message: res.msg, type: "success" });
    //   } else {
    //     this.$message.error(res.msg);
    //   }
    //   return res;
    // },
    //  //TODO：查询所有应急小组
    //  async getSuTemPages(params) {
    //   let { pageNum, pageSize, name } = params;
    //   let res = await this.$http.get("/tenant/emergency/group/list", {
    //     name: name ?? null,
    //     pageNum,
    //     pageSize,
    //   });
    //   return res;
    // },

    // //根据ID查询详细
    // async getSuTemInfo(id) {
    //   let res = await this.$http.get(`/tenant/emergency/group/${id}`);
    //   console.log(res)
    //   return res.data;
    // },
  },
};
